import { v4 as uuidv4 } from "uuid";
import { IBanHangActionTypes } from "../../action-types/ban-hang/IBanHangActionType";
import {
  IBanHangReducer,
  IBanHangTabReducer,
} from "../../reducer-model/ban-hang/IBanHangReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniTab: IBanHangTabReducer = {
  id: uuidv4(),
  title: "Untitled",
  step: 0,
  donHangId: 0,
  donHangRowSelectedId: 0,
  status: eReducerStatusBase.is_not_initialization,
  request: {
    id: 0,
    uf_kho_id: parseInt(localStorage.getItem("uf_kho_id") ?? "0") ?? 0,
    dm_coso_id: parseInt(localStorage.getItem("dm_coso_id") ?? "0") ?? 0,
    ts_hocsinh_id: 0,
    items: [],
    thanhToans: [],
    ma_don_hang_doi_tra: "",
    uf_settieuchuan_id: 0,
  },
  categorySelectedId: 0,
  isShowHistory: false,
  isShowPrint: false,
  donHangViewDetail: {
    id: 0,
    uf_kho_id: parseInt(localStorage.getItem("uf_kho_id") ?? "0") ?? 0,
    dm_coso_id: parseInt(localStorage.getItem("dm_coso_id") ?? "0") ?? 0,
    ts_hocsinh_id: 0,
    uf_settieuchuan_id: 0,
    items: [],
    thanhToans: [],
    ma_don_hang_doi_tra: "",
    uf_trangthaidonhang_id: 0,
  },
  isShowHuyDonHang: false,
  isShowDoiTraModal: false,
  isShowCapNhatDaGiaoHang: false,
  lyDoHuy: "",
  setTieuChuanHocSinhPendingIds: [],
  saleSetHocSinh: [],
  isOrderStepsModalOpen: false,
  isViewingOrderDetails: false,
};
const iniState: IBanHangReducer = {
  selectedId: "hoc-sinh",
  tabs: [],
};
export const banHangReducer = (
  state: IBanHangReducer = iniState,
  action: IBanHangActionTypes
): IBanHangReducer => {
  // DEBUG: Track actions that affect donHangViewDetail
  const debugActions = [
    "BAN_HANG_SHOW_ORDER_STEPS_MODAL",
    "BAN_HANG_CHANGE_SHOW_PRINT",
    "BAN_HANG_CHANGE_SHOW_DOI_TRA_DON_HANG",
    "BAN_HANG_UPDATE_TAB_DATA",
    "BAN_HANG_GET_DETAIL_VIEW_START",
    "BAN_HANG_GET_DETAIL_VIEW_SUCCESS",
  ];
  if (debugActions.includes(action.type)) {
    console.log(`[banHangReducer] Action: ${action.type}`, { payload: action.payload });
  }
  switch (action.type) {
    case "BAN_HANG_ADD_NEW_TAB": {
      const id = uuidv4();
      const hocSinh: any = action.payload;

      let newTab: IBanHangTabReducer = {
        ...iniTab,
        id,
        isShowHistory: false,
      };

      if (hocSinh && hocSinh.id) {
        newTab = {
          ...newTab,
          title: hocSinh.ho_ten || newTab.title,
          hocSinh: hocSinh,
          request: {
            ...newTab.request,
            ts_hocsinh_id: hocSinh.id,
          },
          donHangViewDetail: {
            ...newTab.donHangViewDetail!,
            ts_hocsinh_id: hocSinh.id,
          },
        };
      }

      return {
        ...state,
        selectedId: id,
        tabs: [newTab, ...state.tabs],
      };
    }
    case "BAN_HANG_REMOVE_TAB": {
      const remainingTabs = state.tabs.filter((t) => t.id !== action.payload);
      return {
        ...state,
        tabs: remainingTabs,
        selectedId: remainingTabs.length > 0 ? remainingTabs[0].id : "hoc-sinh",
      };
    }
    case "BAN_HANG_UPDATE_TAB_DATA":
      const updatedTabs = state.tabs.map((t) => {
        if (t.id === action.payload.id) {
          return {
            ...action.payload,
            // Giữ isOrderStepsModalOpen từ state hiện tại, không cho stale closure ghi đè
            isOrderStepsModalOpen: t.isOrderStepsModalOpen,
          };
        }
        return t;
      });

      return {
        ...state,
        tabs: updatedTabs,
      };
    case "BAN_HANG_CHANGEG_SELECTED_TAB":
      return {
        ...state,
        selectedId: action.payload,
      };
    case "BAN_HANG_CREATE_DONHANG_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.tabId) {
            return {
              ...t,
              status: eReducerStatusBase.is_saving,
            };
          }
          return {
            ...t,
          };
        }),
      };
    case "BAN_HANG_CREATE_DONHANG_SUCCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.tabId) {
            return {
              ...t,
              donHangId: action.payload.data,
              // Không tự động hiển thị modal print sau khi tạo đơn hàng
              // isShowPrint: true,
              status: eReducerStatusBase.is_completed,
            };
          }
          return {
            ...t,
          };
        }),
      };
    case "BAN_HANG_CREATE_DONHANG_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.tabId) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
            };
          }
          return {
            ...t,
          };
        }),
      };
    case "BAN_HANG_LOAD_DON_HANG_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.tabId) {
            return {
              ...t,
              status: eReducerStatusBase.is_loading,
            };
          }
          return {
            ...t,
          };
        }),
      };
    case "BAN_HANG_LOAD_DON_HANG_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.tabId) {
            return {
              ...t,
              donHangs: action.payload.data,
              status: eReducerStatusBase.is_completed,
            };
          }
          return {
            ...t,
          };
        }),
      };
    case "BAN_HANG_LOAD_DON_HANG_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.tabId) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
            };
          }
          return {
            ...t,
          };
        }),
      };
    case "BAN_HANG_CHANGE_ROW_SELECTED_ID":
      return {
        ...state,
        tabs: state.tabs.map((tab) => {
          if (tab.id === state.selectedId) {
            return {
              ...tab,
              donHangRowSelectedId: action.payload,
            };
          }
          return tab;
        }),
      };
    case "BAN_HANG_CHANGE_SELECTED_ID":
      return {
        ...state,
        tabs: state.tabs.map((tab) => {
          if (tab.id === state.selectedId) {
            return {
              ...tab,
              donHangId: action.payload,
            };
          }
          return tab;
        }),
      };
    case "BAN_HANG_CHANGE_SHOW_HISTORY":
      return {
        ...state,
        tabs: state.tabs.map((tab) => {
          if (tab.id === state.selectedId) {
            return {
              ...tab,
              isShowHistory: action.payload,
            };
          }
          return tab;
        }),
      };
    case "BAN_HANG_CHANGE_SHOW_PRINT":
      return {
        ...state,
        tabs: state.tabs.map((tab) => {
          if (tab.id === state.selectedId) {
            if (action.payload === false) {
              // Khi đóng modal in, reset lại toàn bộ thông tin giống như "Tạo đơn hàng mới"
              return {
                ...tab,
                isShowPrint: false,
                donHangViewDetail: undefined,
                isViewingOrderDetails: false, // Reset flag khi đóng modal in
                request: {
                  ...tab.request,
                  items: [],
                  thanhToans: [],
                  id: 0,
                  uf_kho_id:
                    parseInt(localStorage.getItem("uf_kho_id") ?? "0") ?? 0,
                  dm_coso_id:
                    parseInt(localStorage.getItem("dm_coso_id") ?? "0") ?? 0,
                  ts_hocsinh_id: 0,
                  ma_don_hang_doi_tra: "",
                  uf_settieuchuan_id: 0,
                },
                donHangId: 0,
                donHangRowSelectedId: 0,
                status: eReducerStatusBase.is_completed,
              };
            }
            return {
              ...tab,
              isShowPrint: action.payload,
            };
          }
          return tab;
        }),
      };
    case "BAN_HANG_SHOW_ORDER_STEPS_MODAL":
      return {
        ...state,
        tabs: state.tabs.map((tab) => {
          if (tab.id === state.selectedId) {
            // When closing modal (action.payload === false), reset donHangViewDetail
            if (action.payload === false) {
              return {
                ...tab,
                isOrderStepsModalOpen: false,
                donHangViewDetail: undefined,
                isViewingOrderDetails: false, // Reset flag khi đóng modal
                request: {
                  ...tab.request,
                  items: [],
                  thanhToans: [],
                  id: 0,
                  uf_kho_id:
                    parseInt(localStorage.getItem("uf_kho_id") ?? "0") ?? 0,
                  dm_coso_id:
                    parseInt(localStorage.getItem("dm_coso_id") ?? "0") ?? 0,
                  ts_hocsinh_id: 0,
                  ma_don_hang_doi_tra: "",
                  uf_settieuchuan_id: 0,
                },
                donHangId: 0,
                donHangRowSelectedId: 0,
                status: eReducerStatusBase.is_completed,
              };
            }
            return {
              ...tab,
              isOrderStepsModalOpen: action.payload,
            };
          }
          return tab;
        }),
      };
    case "BAN_HANG_CHANGE_SHOW_HUY_DON_HANG":
      return {
        ...state,
        tabs: state.tabs.map((tab) => {
          if (tab.id === state.selectedId) {
            if (action.payload === false) {
              return {
                ...tab,
                isShowHuyDonHang: false,
                donHangId: 0,
                donHangRowSelectedId: 0,
              };
            }
            return {
              ...tab,
              isShowHuyDonHang: action.payload,
            };
          }
          return tab;
        }),
      };
    case "BAN_HANG_CHANGE_LY_DO_HUY_DON_HANG":
      return {
        ...state,
        tabs: state.tabs.map((tab) => {
          if (tab.id === state.selectedId) {
            return {
              ...tab,
              lyDoHuy: action.payload,
            };
          }
          return tab;
        }),
      };

    case "BAN_HANG_GET_DETAIL_VIEW_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.tabId) {
            return {
              ...t,
              donHangId: action.payload.data,
              // Chỉ set isViewingOrderDetails = true nếu không phải đang mở modal đổi trả hoặc modal in
              isViewingOrderDetails: !t.isShowDoiTraModal && !t.isShowPrint,
            };
          }
          return t;
        }),
      };
    case "BAN_HANG_GET_DETAIL_VIEW_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.tabId) {
            // Xử lý items để phân biệt số lượng đã đổi trả và số lượng muốn đổi trả
            const processedItems = action.payload.data.items.map((item: any) => ({
              ...item,
              so_luong_da_doi_tra: item.so_luong_doi_tra || 0, // Lưu số lượng đã đổi trả trước đó
              so_luong_doi_tra: 0, // Reset về 0 cho lần đổi trả mới
            }));

            return {
              ...t,
              donHangViewDetail: action.payload.data,
              request: {
                ...action.payload.data,
                items: processedItems,
              },
              // Mở modal ngay khi data load xong nếu đang xem chi tiết
              // Atomic update tránh race condition với UPDATE_TAB_DATA từ các effect khác
              isOrderStepsModalOpen: t.isViewingOrderDetails ? true : t.isOrderStepsModalOpen,
            };
          }
          return t;
        }),
      };
    case "BAN_HANG_GET_DETAIL_VIEW_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.tabId) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              donHangId: 0,
              donHangRowSelectedId: 0,
              isViewingOrderDetails: false,
            };
          }
          return t;
        }),
      };
    case "BAN_HANG_HUY_DON_HANG_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.tabId) {
            return {
              ...t,
              status: eReducerStatusBase.is_saving,
            };
          }
          return {
            ...t,
          };
        }),
      };
    case "BAN_HANG_HUY_DON_HANG_SUCCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.tabId) {
            return {
              ...t,
              isShowHuyDonHang: false,
              donHangId: 0,
              donHangRowSelectedId: 0,
              status: eReducerStatusBase.is_completed,
            };
          }
          return {
            ...t,
          };
        }),
      };
    case "BAN_HANG_HUY_DON_HANG_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.tabId) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              isShowHuyDonHang: false,
              donHangId: 0,
              donHangRowSelectedId: 0,
            };
          }
          return {
            ...t,
          };
        }),
      };
    case "BAN_HANG_CHANGE_SHOW_DOI_TRA_DON_HANG":
      return {
        ...state,
        tabs: state.tabs.map((tab) => {
          if (tab.id === state.selectedId) {
            if (action.payload === false) {
              return {
                ...tab,
                isShowDoiTraModal: false,
                donHangViewDetail: undefined,
                isViewingOrderDetails: false, // Reset flag khi đóng modal đổi trả
                request: {
                  ...tab.request,
                  items: [],
                  thanhToans: [],
                  id: 0,
                  uf_kho_id:
                    parseInt(localStorage.getItem("uf_kho_id") ?? "0") ?? 0,
                  dm_coso_id:
                    parseInt(localStorage.getItem("dm_coso_id") ?? "0") ?? 0,
                  ghi_chu: "",
                  uf_settieuchuan_id: 0,
                },
                donHangId: 0,
                donHangRowSelectedId: 0,
                status: eReducerStatusBase.is_completed,
              };
            }
            return {
              ...tab,
              isShowDoiTraModal: action.payload,
              // Khi mở modal đổi trả, set isViewingOrderDetails = false
              // để không ảnh hưởng đến việc hiển thị lịch sử
              isViewingOrderDetails: false,
            };
          }
          return tab;
        }),
      };
    case "BAN_HANG_DOI_TRA_DON_HANG_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.tabId) {
            return {
              ...t,
              status: eReducerStatusBase.is_saving,
            };
          }
          return {
            ...t,
          };
        }),
      };
    case "BAN_HANG_DOI_TRA_DON_HANG_SUCCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.tabId) {
            return {
              ...t,
              isShowDoiTraModal: false,
              donHangViewDetail: undefined,
              isViewingOrderDetails: false, // Reset flag để hiển thị lịch sử
              request: {
                ...t.request,
                items: [],
                thanhToans: [],
                id: 0,
                uf_kho_id:
                  parseInt(localStorage.getItem("uf_kho_id") ?? "0") ?? 0,
                dm_coso_id:
                  parseInt(localStorage.getItem("dm_coso_id") ?? "0") ?? 0,
                ghi_chu: "",
                uf_settieuchuan_id: 0,
              },
              donHangId: 0,
              donHangRowSelectedId: 0,
              status: eReducerStatusBase.is_need_reload, // Set need reload để tự động reload lịch sử
            };
          }
          return {
            ...t,
          };
        }),
      };
    case "BAN_HANG_DOI_TRA_DON_HANG_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.tabId) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              isShowDoiTraModal: false,
              donHangViewDetail: undefined,
              isViewingOrderDetails: false,
              request: {
                ...t.request,
                items: [],
                thanhToans: [],
                id: 0,
              },
              donHangId: 0,
              donHangRowSelectedId: 0,
            };
          }
          return {
            ...t,
          };
        }),
      };
    case "BAN_HANG_CHANGE_SHOW_CAP_NHAT_DA_GIAO_HANG":
      return {
        ...state,
        tabs: state.tabs.map((tab) => {
          if (tab.id === state.selectedId) {
            if (action.payload === false) {
              return {
                ...tab,
                isShowCapNhatDaGiaoHang: false,
                donHangId: 0,
                donHangRowSelectedId: 0,
              };
            }
            return {
              ...tab,
              isShowCapNhatDaGiaoHang: action.payload,
            };
          }
          return tab;
        }),
      };
    case "BAN_HANG_CAP_NHAT_DA_GIAO_HANG_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.tabId) {
            return {
              ...t,
              status: eReducerStatusBase.is_saving,
            };
          }
          return {
            ...t,
          };
        }),
      };
    case "BAN_HANG_CAP_NHAT_DA_GIAO_HANG_SUCCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.tabId) {
            return {
              ...t,
              isShowCapNhatDaGiaoHang: false,
              donHangId: 0,
              donHangRowSelectedId: 0,
              status: eReducerStatusBase.is_completed,
            };
          }
          return {
            ...t,
          };
        }),
      };
    case "BAN_HANG_CAP_NHAT_DA_GIAO_HANG_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.tabId) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
            };
          }
          return {
            ...t,
          };
        }),
      };
    default:
      return state;
  }
};
